import React, { createContext, useEffect, useReducer } from 'react';
// import { AbstractProvider } from 'web3-core';
import reducer from './reducer';
import EventTypes from '../constants/eventTypes';
import useActionsHook from './actions';
import { IEventObserverClass } from '../services/EventObserver';
import { IAction, INetwork } from './stateConstants';
import { INPAGE_KEY, TWalletType } from '../constants/wallet';

// export const eventObserverAction = {
//   set: Symbol('SET_EVENT_OBSERVER'),
// };

export type IDispatch = (arg: IAction) => void;

const initialState: IContext = {
  state: undefined,
  dispatch: () => {},
};

export interface IContextState {
  networkId: number
  account: string
  connectingWalletType: TWalletType | null
  accountType: string
  connectionType: string
  network: INetwork
  connectingWallet: boolean
  connectionError: string
  isModalOpen: boolean
  isLedgerModalOpen: boolean
  isTrezorModalOpen: boolean
  // provider?: AbstractProvider
  balanceWei?: string
  balanceLoading?: boolean
}

interface IContext {
  dispatch: IDispatch
  state: IContextState
}

export const Context = createContext<IContext>(initialState);

const { Provider } = Context;

interface IStateProvider {
  eventObserver: IEventObserverClass
}

export const StateProvider: React.FC<IStateProvider> = ({ children, eventObserver }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const actions = useActionsHook(dispatch);

  useEffect(() => {
    eventObserver.on({
      eventType: EventTypes.DISPATCH,
      callback: dispatch,
    });

    eventObserver.on({
      eventType: EventTypes.CONNECT_REQUEST_COMPONENT,
      callback: (...params) => actions.connectWallet(...params),
    });

    eventObserver.on({
      eventType: EventTypes.DISCONNECT,
      callback: () => actions.disconnect(),
    });
    const enforceConnection = localStorage.getItem(INPAGE_KEY);
    if (enforceConnection) {
      try {
        actions.connectWallet({ ...JSON.parse(enforceConnection), removeLSKey: true });
      } catch (err) {
        localStorage.removeItem(INPAGE_KEY);
      }
    }
    return () => {
      eventObserver.off();
    };
  }, []);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};
